export const tapInto =
  <T>(callback: (value: T) => unknown) =>
  (value: T): T => (callback(value), value);

export const mapValue =
  <T, R>(callback: (value: T) => R) =>
  (value: T): R =>
    callback(value);
